import { Suspense } from "react";
import ProvidersWrapper from "ProvidersWrapper";
import { ToastContainer } from "react-toastify";
import { RouterConfig } from "navigation/RouterConfig";
import { useLoginCheck, useClearCache } from "hooks";
import { withErrorBoundary, useErrorBoundary } from "react-use-error-boundary";
import UnderMaintenanceCheck from "UnderMaintenanceCheck";
import ErrorHandler from "ErrorHandler";
import Loading from "components/Loading";
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  useLoginCheck();
  useClearCache();
  const [error, resetError] = useErrorBoundary();

  if (error) {
    return <ErrorHandler error={error} resetError={resetError} />;
  }

  return (
    <UnderMaintenanceCheck>
      <ProvidersWrapper>
        <ToastContainer />
        <Suspense fallback={<Loading />}>
          <RouterConfig />
        </Suspense>
      </ProvidersWrapper>
    </UnderMaintenanceCheck>
  );
};

export default withErrorBoundary(App);
